import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { useCallContext } from '@src/app/voice/ongoing-call/context/useCallContext'
import { Collapsible } from '@src/component'
import type { ActiveCallParticipant } from '@src/service/voice'
import Typography from '@ui/Typography'

import * as styles from './ParticipantsList.css'
import { ParticipantRow } from './participant-row'

const List = ({ participants }: { participants: ActiveCallParticipant[] }) => {
  return (
    <div className={styles.list}>
      {participants.map((participant) => (
        <ParticipantRow key={participant.id} participant={participant} />
      ))}
    </div>
  )
}

const CollapsibleList = ({
  participants,
  label,
}: {
  participants: ActiveCallParticipant[]
  label: string
}) => {
  const [open, setOpen] = useState(false)

  return participants.length ? (
    <Collapsible
      open
      headerClassName={styles.label}
      contentClassName={styles.content}
      onToggle={() => setOpen((o) => !o)}
      title={() => (
        <Typography variant="caption1" fontWeight="medium" color="textTertiary">
          {label} {open ? null : participants.length}
        </Typography>
      )}
    >
      <List participants={participants} />
    </Collapsible>
  ) : null
}

const ParticipantsList = () => {
  const { call } = useCallContext()
  const { listeners, speakers, whisperers } = call.participants

  return (
    <div className={styles.root}>
      <List participants={speakers} />
      <CollapsibleList participants={whisperers} label="Whispering" />
      <CollapsibleList participants={listeners} label="Listeners" />
    </div>
  )
}

export default observer(ParticipantsList)
